<template>
	<div class="creator-nvidia" id="rtx-studio-desktop">
		<section
			v-for="section in creatorNvidiaData"
			:key="section.id"
			class="creator-nvidia__section"
			:style="`background-image: url('${ section.background_url }')`"
			:id="Number(section.sort_order) && 'external-drive'"
		>
			<div class="container">
				<div class="col-md-6">
					<h3 class="creator-nvidia__section__heading">
						{{ section.title | stripTags }}
					</h3>
					<div class="creator-nvidia__section__body" v-html="section.body" />
					<img
						v-if="section.mini_logo_url"
						class="creator-nvidia__section__mini-logo"
						:src="section.mini_logo_url"
						:alt="section.title"
					>
				</div>
				<div class="col-md-6">
					<div class="creator-nvidia__section__img">
						<img
							v-if="section.logo_url"
							:src="section.logo_url"
							:alt="section.title"
						>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import { mapState } from "vuex";

export default {
	name: "CreatorNvidia",
	computed: {
		...mapState({
			creatorNvidiaData: state => state.StarterPc.pageData.landing_page_sections.slice(8, 14)
		})
	}
};
</script>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.creator-nvidia {
    &__section:nth-child(1) {
        @media (max-width: 700px) {
            background-image: url("/images/creators-pc/nvidia-sections-mobile-bg/nvidia-section-mobile-background-1.jpg") !important;
        }
    }

    &__section:nth-child(2) {
        @media (max-width: 700px) {
            background-image: url("/images/creators-pc/nvidia-sections-mobile-bg/nvidia-section-mobile-background-2.jpg") !important;
        }
    }

    &__section:nth-child(3) {
        @media (max-width: 700px) {
            background-image: url("/images/creators-pc/nvidia-sections-mobile-bg/nvidia-section-mobile-background-3.jpg") !important;
        }
    }

    &__section:nth-child(4) {
        @media (max-width: 700px) {
            background-image: url("/images/creators-pc/nvidia-sections-mobile-bg/nvidia-section-mobile-background-4.jpg") !important;
            padding-top: 40px;
        }
    }

    &__section:nth-child(5) {
        @media (max-width: 700px) {
            background-image: url("/images/creators-pc/nvidia-sections-mobile-bg/nvidia-section-mobile-background-5.jpg") !important;
            padding-top: 250px;
        }
    }

    &__section:nth-child(6) {
        @media (max-width: 700px) {
            padding-top: 40px;
        }
    }

    &__section {
        color: $white;
        background-size: cover;

        @media (min-width: 700px) and (max-width: 1200px) {
            background-position-x: 70%;
        }

        @media (min-width: 700px) {
            height: 540px;
        }

        .container {
            height: 100%;
            display: flex;
            align-items: center;

            @media (max-width: 700px) {
                flex-direction: column-reverse;

                .col-md-6 {
                    padding: 0;
                }
            }
        }

        @media (max-width: 700px) {
            padding-top: 390px;
            padding-bottom: 25px;
        }

        &__heading {
            font-size: 36px;
        }

        &__body {
            max-width: 450px;
            font-size: 16px;
            line-height: 28px;
        }

        &__mini-logo {
            margin-top: 25px;
        }

        &__img {
            max-width: 450px;
            margin-left: auto;

            @media (max-width: 1200px) {
                max-width: 360px;
            }

            @media (max-width: 700px) {
                max-width: 100%;
                margin-bottom: 30px;
            }

            img {
                width: 100%;
            }
        }
    }
}
</style>

<style lang="scss">
.creator-nvidia__section__body {
    p {
        margin: 0;
    }
}
</style>
